/* ============================================================
   LEOSPORTZ — theme-utils.js
   Shared utilities used across all theme modules.
   ============================================================ */

'use strict';

window.Leosportz = window.Leosportz || {};

Leosportz.utils = {
  $(sel, ctx = document) { return ctx.querySelector(sel); },
  $$(sel, ctx = document) { return [...ctx.querySelectorAll(sel)]; },

  on(el, event, fn, opts) {
    if (el) el.addEventListener(event, fn, opts);
  },

  debounce(fn, ms = 200) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  },

  formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  },

  // Throttle helper
  throttle(fn, ms = 100) {
    let last = 0;
    return (...args) => {
      const now = Date.now();
      if (now - last >= ms) { last = now; fn(...args); }
    };
  },
};

/* ─── Featured Products Slider ────────────────────────────── */
Leosportz.FeaturedSlider = {
  init() {
    document.querySelectorAll('.fp-slider').forEach(track => {
      const id = track.id;
      if (!id) return;
      const prevBtn = document.querySelector(`.fp-arrow--prev[data-slider="${id}"]`);
      const nextBtn = document.querySelector(`.fp-arrow--next[data-slider="${id}"]`);
      if (!prevBtn || !nextBtn) return;

      const slideWidth = () => {
        const slide = track.querySelector('.fp-slide');
        if (!slide) return 0;
        const gap = parseInt(getComputedStyle(track).gap) || 16;
        return slide.offsetWidth + gap;
      };

      const updateArrows = () => {
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.offsetWidth - 4;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  },
};
